"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Faker = void 0;
var outseta_1 = require("outseta");
var uuid_1 = require("uuid");
var __1 = require("..");
var Faker = /** @class */ (function () {
    function Faker() {
    }
    var _a;
    _a = Faker;
    Faker.getCardmarketArticleSeller = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return __assign({ isCommercial: __1.SellerLevel.Private, reputation: __1.Reputation.Good, sellCount: 1000, username: 'SellerMan', country: 'D', address: {
                country: overrides.country || 'D',
            } }, overrides);
    };
    Faker.getExpansion = function (overrides) {
        return __assign({ _id: 1, name: 'Expansion', code: 'EXP', releaseDate: new Date(), isReleased: true, idGame: __1.IdGame.Magic, localization: {
                DE: '[DE]Expansion',
                FR: '[FR]Expansion',
                IT: '[IT]Expansion',
                ES: '[ES]Expansion',
            }, icon: 1 }, overrides);
    };
    Faker.getCompetitor = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return __assign({ reputation: __1.Reputation.Good, excludedUsers: [], level: __1.SellerLevel.Private, sellCount: 0, countries: [] }, overrides);
    };
    Faker.getPricingStrategy = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return __assign({ base: {
                kind: 'articleData',
                tactic: {
                    parameter: 1,
                    competitor: '321',
                },
            }, modifier: {
                kind: 'number',
                value: 5,
            }, disableBulkPricing: false, NMeqEX: false, disablePlaysetPricing: false, strictLanguage: false, name: 'Undercut Private', bulkSettingsId: {
                1: '1',
            } }, overrides);
    };
    Faker.getPricingStrategyPriceGuide = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return __assign({ base: {
                kind: 'priceGuide',
                tactic: {
                    parameter: 'AVG7',
                },
            }, modifier: {
                kind: 'number',
                value: 0,
            }, disableBulkPricing: false, NMeqEX: false, disablePlaysetPricing: false, strictLanguage: false, name: 'Avg7 100%', bulkSettingsId: {
                1: '1',
            } }, overrides);
    };
    Faker.getPricingStrategyWithCompetitor = function (overrides, competitorOverrides) {
        if (overrides === void 0) { overrides = {}; }
        if (competitorOverrides === void 0) { competitorOverrides = {}; }
        var id = (0, uuid_1.v4)();
        return {
            competitor: _a.getCompetitor(__assign(__assign({}, competitorOverrides), { _id: id })),
            pricingStrategy: _a.getPricingStrategy(__assign(__assign({}, overrides), { base: {
                    kind: 'articleData',
                    tactic: {
                        parameter: 1,
                        competitor: id,
                    },
                } })),
        };
    };
    Faker.getAutopricingAssignment = function (overrides) {
        return __assign({ articles: [
                Faker.getArticle().attributes,
                Faker.getArticle().attributes,
                Faker.getArticle().attributes,
            ], idGame: __1.IdGame.Magic, pricingStrategyId: '123' }, overrides);
    };
    Faker.getInventoryArticle = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return new __1.InventoryArticle(__assign(__assign({}, overrides), Faker.getRichArticle(overrides)));
    };
    Faker.getPricedInventoryArticle = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return new __1.PricedInventoryArticle(__assign(__assign({ priceReport: { failure: 'oops' } }, overrides), Faker.getRichArticle(overrides)));
    };
    Faker.getRichArticle = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return new __1.RichArticle(__assign({ idArticle: '123', idProduct: 1, isFoil: false, isPlayset: false, isReverseHolo: false, isSigned: false, isFirstEd: false, price: 1, branded: false, condition: 'EX', idLanguage: __1.CardLanguage.English, quantity: 1, card: {
                _id: 1,
                cn: '1',
                rarity: 1,
                set: 'IDK',
                expansion: 'Expansion',
                name: 'Card Name',
                locNames: {
                    DE: '',
                    ES: '',
                    FR: '',
                    IT: '',
                },
            } }, overrides));
    };
    Faker.getArticle = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return new __1.Article(__assign({ idProduct: 1, idLanguage: __1.CardLanguage.English, condition: 'NM', isFoil: false, isPlayset: false, isSigned: false, isFirstEd: false, isReverseHolo: false, price: 1 }, overrides));
    };
    Faker.getCardmarketArticle = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return new __1.CardmarketArticle(__assign(__assign({}, Faker.getPlainCardmarketArticle(overrides)), overrides));
    };
    Faker.getPlainCardmarketArticle = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        var seller = Faker.getCardmarketArticleSeller(overrides.seller);
        return __assign({ comments: '', condition: 'EX', count: 1, idArticle: '123', language: {
                idLanguage: __1.CardLanguage.English,
                languageName: 'English',
            }, idProduct: 1, isFoil: false, isPlayset: false, isReverseHolo: false, isSigned: false, isFirstEd: false, price: overrides.price || 1, seller: __assign(__assign({}, seller), { address: { country: seller.country } }), prices: [
                {
                    currencyCode: 'EUR',
                    price: overrides.price || 1,
                    idCurrency: 1,
                },
                {
                    currencyCode: 'GBP',
                    price: (overrides.price || 1) * 0.84,
                    idCurrency: 2,
                },
            ] }, overrides);
    };
    Faker.getArticleData = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        var privateSeller = Faker.getCardmarketArticleSeller({
            isCommercial: __1.SellerLevel.Private,
            sellCount: 10,
        });
        var professionalSeller = Faker.getCardmarketArticleSeller({
            isCommercial: __1.SellerLevel.Professional,
            sellCount: 1500,
        });
        var powerSeller = Faker.getCardmarketArticleSeller({
            isCommercial: __1.SellerLevel.Powerseller,
            sellCount: 5000,
            country: 'ES',
        });
        var data = [
            _a.getCardmarketArticle({
                seller: privateSeller,
            }),
            _a.getCardmarketArticle({
                seller: professionalSeller,
            }),
            _a.getCardmarketArticle({
                seller: powerSeller,
            }),
            _a.getCardmarketArticle(),
            _a.getCardmarketArticle(),
        ];
        return __assign({ _id: 1, data: data, fetchedAt: new Date() }, overrides);
    };
    Faker.getCardDataItem = function (overrides) {
        var card = __assign({ _id: 1, cn: '1', rarity: 1, set: 'IDK', expansion: 'Expansion', name: 'Card Name', locNames: {
                DE: '',
                ES: '',
                FR: '',
                IT: '',
            } }, overrides);
        return card;
    };
    Faker.getCard = function (overrides) {
        var card = new __1.Card({
            cardDataItem: __assign({ _id: 1, cn: '1', rarity: 1, set: 'IDK', expansion: 'Expansion', name: 'Card Name', locNames: {
                    DE: '',
                    ES: '',
                    FR: '',
                    IT: '',
                } }, overrides),
        });
        return card;
    };
    Faker.getCardPriceGuide = function (overrides) {
        var guide = new __1.CardPriceGuide({
            priceGuide: __assign({ AVG1: 1, AVG7: 2, AVG30: 3, FoilAVG1: 4, FoilAVG7: 5, FoilAVG30: 6, FoilTrend: 7, Trend: 8 }, overrides),
        });
        return guide;
    };
    Faker.getCardWithPriceGuide = function (overrides, priceGuideOverrides) {
        var card = new __1.WorkerCard({
            idGame: 1,
            cardDataItem: __assign({ _id: 1, cn: '1', rarity: 1, set: 'IDK', expansion: 'Expansion', name: 'Card Name', locNames: {
                    DE: '',
                    ES: '',
                    FR: '',
                    IT: '',
                } }, overrides),
            scryfallId: overrides === null || overrides === void 0 ? void 0 : overrides.scryfallId,
            priceGuide: _a.getCardPriceGuide(__assign({}, priceGuideOverrides)),
        });
        return card;
    };
    Faker.getPricingPlan = function (overrides, _b) {
        if (overrides === void 0) { overrides = {}; }
        var _c = _b === void 0 ? {} : _b, defaultMethod = _c.defaultMethod;
        var pricingPlan = __assign({ _id: (0, uuid_1.v4)(), idGame: __1.IdGame.Magic, name: 'Pricing Plan', settings: {
                maxValueDecrease: __1.PRICING_DEFAULTS.maxDecrease,
                maxValueIncrease: __1.PRICING_DEFAULTS.maxIncrease,
                maxValueIncreaseEnabled: true,
            }, defaultNode: {
                id: 'default',
                method: defaultMethod || null,
            }, nodes: [] }, overrides);
        return pricingPlan;
    };
    Faker.getPricingPlanNode = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        var node = __assign({ id: (0, uuid_1.v4)(), conditionStrictness: __1.ConditionStrictness.all, conditions: [
                {
                    id: '41232',
                    type: __1.ConditionTypesEnum.Language,
                    value: [__1.CardLanguage.Japanese],
                },
            ], method: null, children: [] }, overrides);
        return node;
    };
    Faker.getOutseta = function () {
        var outseta = {
            currentSubscription: {
                id: (0, uuid_1.v4)(),
                planId: outseta_1.OutsetaSubscriptionId.Collector,
            },
            accountStage: outseta_1.OutsetaAccountStage.Subscribing,
            dayPasses: {},
        };
        return outseta;
    };
    Faker.getUser = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        var user = __assign({ _id: (0, uuid_1.v4)(), username: 'fakeUsername', cardmarketUsername: 'fakeCardmarketUsername', assignedCardmarketAccounts: [
                {
                    _id: (0, uuid_1.v4)(),
                    username: 'fakeCardmarketUsername',
                    currency: 'EUR',
                    professional: false,
                },
            ], language: 'en', outsetaAccountId: 'fakeOutsetaAccountId', pricingStrategies: [_a.getPricingStrategy()], competitors: [], hasResetAccount: false, articlesPublishedToday: 0, createdAt: new Date(), currency: 'EUR', bulkSettings: [], pricingPlans: [_a.getPricingPlan()], addBranding: false, activeBots: [], outseta: _a.getOutseta(), canUsePricingBot: true, rollingBotActive: true }, overrides);
        return user;
    };
    return Faker;
}());
exports.Faker = Faker;
//# sourceMappingURL=Faker.js.map